var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2V5M16 2V5M3.5 9.09H20.5M22 19C22 19.75 21.79 20.46 21.42 21.06C21.0675 21.6525 20.5667 22.143 19.967 22.4831C19.3674 22.8233 18.6894 23.0014 18 23C16.99 23 16.07 22.63 15.37 22C15.06 21.74 14.79 21.42 14.58 21.06C14.1993 20.4404 13.9985 19.7272 14 19C14 16.79 15.79 15 18 15C19.2 15 20.27 15.53 21 16.36C21.6431 17.0892 21.9986 18.0277 22 19Z",
    stroke: "#0A95D6",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16V8.5C21 5.5 19.5 3.5 16 3.5H8C4.5 3.5 3 5.5 3 8.5V17C3 20 4.5 22 8 22H15",
    stroke: "#0A95D6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9949 13.7002H12.0049M8.29395 13.7002H8.30395M8.29395 16.7002H8.30395",
    stroke: "#0A95D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_659_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2775 17.27C17.495 17.205 17.735 17.1625 18 17.1625C19.1975 17.1625 20.1675 18.1325 20.1675 19.33C20.1675 20.5275 19.1975 21.4975 18 21.4975C16.8025 21.4975 15.8325 20.5275 15.8325 19.33C15.8325 18.885 15.9675 18.47 16.1975 18.125M17.69 16.5L16.9675 17.33L17.81 17.945",
    stroke: "#0A95D6",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_659_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(15 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarReload);
export default __webpack_public_path__ + "static/media/calendar-reload.400b966cf9cbb4663459aeb2f4dfe315.svg";
export { ForwardRef as ReactComponent };